// extracted by mini-css-extract-plugin
export var dividerLine = "_5p-0";
export var errorBackground = "_5p-1";